import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { RoleForm } from "~/components/employees/role-form";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";

// V4.1: Route-based modal for inline role creation during employee creation
const searchParamsSchema = z.object({
  roleName: z.string(),
});

export const Route = createFileRoute(
  "/_authenticated/employees/new/create-role"
)({
  component: CreateRoleModal,
  validateSearch: searchParamsSchema,
});

function CreateRoleModal() {
  const navigate = useNavigate();
  const { roleName } = Route.useSearch();

  const handleClose = () => {
    void navigate({ to: "/employees/new" });
  };

  const handleSuccess = (id: Id<"organizationRoles">) => {
    // Navigate back to parent with new role ID in search params
    void navigate({
      to: "/employees/new",
      search: { newRoleId: id },
    });
  };

  return (
    <Dialog onOpenChange={(open) => !open && handleClose()} open>
      <DialogContent>
        <DialogHeader className="space-y-0">
          <DialogTitle className="subtitle font-heading text-foreground text-center leading-loose">
            Create new role
          </DialogTitle>
          <DialogDescription className="body text-foreground text-center">
            Set up a new role with preset permissions for easier employee
            management across all locations.
          </DialogDescription>
        </DialogHeader>
        <RoleForm isInDialog onSuccess={handleSuccess} roleName={roleName} />
      </DialogContent>
    </Dialog>
  );
}
